var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "c--partner-with-us_breadcrumb new-container mx-auto"
  }, [_c('div', {
    staticClass: "partner-with-us-breadcrumb display-none display-md-grid"
  }, _vm._l(_vm.breadcrumbs, function (breadcrumb, index) {
    return _c('div', {
      key: `partner-with-us-breadcrumb-${index}`,
      staticClass: "partner-with-us-breadcrumb-item"
    }, [_c(breadcrumb.link ? 'nuxt-link' : 'p', {
      tag: "component",
      attrs: {
        "to": _vm.localePath(breadcrumb.link),
        "target": breadcrumb.external ? '_blank' : '_self'
      }
    }, [_vm._v("\n        " + _vm._s(breadcrumb.title) + "\n      ")]), _vm._v(" "), index !== _vm.breadcrumbs.length - 1 ? _c('a-icon', {
      attrs: {
        "type": "image",
        "loader": "data",
        "name": "icon-partner-with-us-breadcrumb-arrow",
        "width": "18"
      }
    }) : _vm._e()], 1);
  }), 0)]);

}
var staticRenderFns = []

export { render, staticRenderFns }